import classNames from "classnames";
import generalStyles from "../../editor-common/statics/styles/general-scss";
import generalRTLIgnoredStyles from "../../wix-rich-content-common/statics/styles/general.rtlignore-scss";
const stylesWithRTL = { ...generalStyles, ...generalRTLIgnoredStyles };
const getContainerClasses = (editor, nodeId, isMobile) => {
  let isFocused = false;
  const selection = editor.state.selection;
  editor.state.doc.nodesBetween(selection.from, selection.to, (node) => {
    node.attrs.id === nodeId && (isFocused = true);
  });
  return classNames(stylesWithRTL.pluginContainer, {
    [stylesWithRTL.pluginContainerMobile]: isMobile,
    [stylesWithRTL.hasFocus]: isFocused,
    [stylesWithRTL.hideTextSelection]: !isFocused
  });
};
export {
  getContainerClasses
};
//# sourceMappingURL=get-container-classes.js.map
